import { useEffect, useState } from "react";
import api from "@/lib/api";

// Badge text for a tournament with a player limit ("" when unlimited). Re-fetches whenever refreshKey changes.
export function useSpotsLabel(eventId, enabled, refreshKey) {
  const [left, setLeft] = useState(null);
  useEffect(() => {
    if (!enabled || !eventId) return;
    api.get(`/tournaments/${eventId}/spots`).then((r) => setLeft(r.data.spots_left)).catch(() => {});
  }, [eventId, enabled, refreshKey]);
  if (left == null) return "";
  return left > 0 ? `${left} spot${left === 1 ? "" : "s"} left` : "Full · join the waiting list";
}
